<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="pv"></a><span epub:type="pagebreak" id="pagev" title="v">CONTENTS</span></h2>
<p class="toc"><a href="#/xhtml/chapter01">1  I find Smirisary</a></p>
<p class="toc"><a href="#/xhtml/chapter02">2  I Became a Crofter in Smirisary</a></p>
<p class="toc"><a href="#/xhtml/chapter03">3  I Settle In</a></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">4  Fire, Water and Bread</span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">5  Byre and Barn</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">6  The Garden and the Blaran Boidheach</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">7  The Lon and the Blar Eorna</span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample">8  Winter Nights</span></p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample">9  Spring Work</span></p>
<p class="toc1"><span href="#/xhtml/chapter10" title="Link target outside of Sample">10  Blossom</span></p>
<p class="toc1"><span href="#/xhtml/chapter11" title="Link target outside of Sample">11  Lovely May</span></p>
<p class="toc1"><span href="#/xhtml/chapter12" title="Link target outside of Sample">12  Cows</span></p>
<p class="toc1"><span href="#/xhtml/chapter13" title="Link target outside of Sample">13  Amenities</span></p>
<p class="toc1"><span href="#/xhtml/chapter14" title="Link target outside of Sample">14  Fences and Drains</span></p>
<p class="toc1"><span href="#/xhtml/chapter15" title="Link target outside of Sample">15  The “Star of Smirisary”</span></p>
<p class="toc1"><span href="#/xhtml/chapter16" title="Link target outside of Sample">16  Birth and Death</span></p>
<p class="toc1"><span href="#/xhtml/chapter17" title="Link target outside of Sample">17  The Land Court Visits Smirisary</span></p>
<p class="toc1"><span href="#/xhtml/chapter18" title="Link target outside of Sample">18  Haymaking</span></p>
<p class="toc1"><span href="#/xhtml/chapter19" title="Link target outside of Sample">19  The Great August Drought</span></p>
<p class="toc1"><span href="#/xhtml/chapter20" title="Link target outside of Sample">20  Autumn Days</span></p>
<p class="toc1"><a id="pvi"></a><span epub:type="pagebreak" id="pagevi" title="vi"><span href="#/xhtml/chapter21" title="Link target outside of Sample">21  The Highland Problem</span></span></p>
<p class="toc1"><span href="#/xhtml/chapter22" title="Link target outside of Sample">22  The Amateur Crofter</span></p>
<p class="toc1"><span href="#/xhtml/chapter23" title="Link target outside of Sample">23  Conclusion</span></p>
<p class="tocc"><a href="#/xhtml/fm02"><em>A Map of Smirisary</em></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7eeb423c